import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CountryRegistrationRestrictionService } from './country-registration-restriction.service';

@Injectable()
export class CountryRegistrationRestrictionGuard implements CanActivate {
  constructor(
    private countryRestrictionService: CountryRegistrationRestrictionService,
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return await this.countryRestrictionService.checkIfUserAllowed();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/country-restriction/country-registration-restriction.guard.ts